import m from 'mithril'

import SignInForm from '../components/sign-in'

var isForGrant = window.location.search.indexOf('oauth=1') >= 0

m.mount(document.getElementById('app'), {
  view: () =>
    m('.flex-centered.flex-col.fullscreen',
      isForGrant && m('.toast.toast-primary.my-2.mw-med.text-center',
        { style: `max-width: 14rem` },
        'An app is requesting permission to store data in your BYOD home.',
        m('br', { style: `line-height: 2rem` }),
        'Please sign in to either accept or reject this request.',
      ),
      m(SignInForm)
    )
})
